import { reportError } from "./lib/telemetry";
import { Component, type ReactNode } from "react";
import { recordNativeFailure } from "./lib/native-diagnostics";
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error) {
    reportError(error, "render");
    void recordNativeFailure("render", error);
  }
  render() {
    return this.state.failed ? (
      <main className="page">
        <h1>Let’s try that again</h1>
        <p>
          Something interrupted this screen. Your saved account and posts are
          safe.
        </p>
        <button onClick={() => window.location.reload()}>
          Reload Lift &amp; Learn
        </button>
      </main>
    ) : (
      this.props.children
    );
  }
}
